import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

//导入组件
const FourFistProduction = lazy(() =>import("@/page/four-fist-production"));
const InnovationElementConfig = lazy(() => import("@/page/innovation-element-config"));
const MapTest = lazy(() => import("@/page/map-test"));
const Login = lazy(() => import("@/page/login-or-register/login"));
const Register = lazy(() => import("@/page/login-or-register/register"));
const AIPage = lazy(() => import("@/page/AI"));
const AISeeMoreSingle = lazy(() => import("@/page/AI-see-more-single"));
const CodeTest = lazy(() => import("@/page/code-test"));

//路由配置文件
const Routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login/>,
  },
  {
    path: "/register",
    element: <Register/>,
  },
  {
    path: "/",
    element: <FourFistProduction/>,
  },
  {
    path: "/innovation",
    element: <InnovationElementConfig/>,
  },
  {
    path: "/map-test",
    element: <MapTest/>,
  },
  {
    path: "/AI",
    element: <AIPage />,
  },
  {
    path: "/AI-see-more",
    element: <AISeeMoreSingle />
  },{
    path: "/code-test",
    element: <CodeTest />
  }
];

export default Routes;